export const session = (function() {

    // localStorage key
    // var key = "e_u_c76d873a8ad241a2a7ef";

    // var userJson = {
    //     userId: undefined,
    //     userName:undefined,

    //     villageId: undefined,
    //     villagesName:undefined,
        
    //     loginTimeStamp: 0,
    //     expireTimeStamp: 0
    // };

    // var setLocalStorage = function() {
    //     window.localStorage.setItem(key, JSON.stringify(userJson));
    // };


    // var getLocalStorage = function() {
    //     var json = window.localStorage.getItem(key);
    //     if (json)
    //         userJson = JSON.parse(json);
    // };

    var setSession = function(userId,userName, villageId,villagesName,code) {
        // userJson.userId = userId;
        // userJson.userName = userName;
        // userJson.villageId = villageId;
        // userJson.villagesName = villagesName;
        // userJson.loginTimeStamp = Date.now();
        // var date = new Date()
        // date.setDate(date.getDate() + 1);
        // var dateTimeStamp = date.valueOf();
        // userJson.expireTimeStamp = dateTimeStamp;
        // setLocalStorage();
        localStorage.setItem('userId', userId);
        localStorage.setItem('userName', userName);
        localStorage.setItem('villageId', villageId);
        localStorage.setItem('code', code);
        localStorage.setItem('villagesName', villagesName);
    }
    var removeSession = function() {
        // window.localStorage.removeItem(key);
        // window.localStorage.clear();
        localStorage.setItem('userId', '');
        localStorage.setItem('userName', '');
        localStorage.setItem('villageId', '');
        localStorage.setItem('villagesName', '');
        localStorage.setItem('loginTime', '');
    }

    var check = function() {
        // getLocalStorage();
        // var date = new Date()
        // date.setDate(date.getDate() + 1);
        // var dateTimeStamp = date.valueOf();
        // return userJson.userId && userJson.villageId && userJson.villagesName && userJson.loginTimeStamp > 0 && dateTimeStamp > Date.now();
    };

    var redirectToLogin = function() {

    }

    var getUserId = function() {
        return localStorage.getItem('userId')
        // if (check())
        //     return userJson.userId;
        // else {
        //     redirectToLogin();
        // }
    };

    var getUserName = function() {
        // if (check())
        //     return userJson.userName;
        // else {
        //     redirectToLogin();
        // }
        return localStorage.getItem('userName')
    };

    var getVillageId = function() {
        // if (check())
        //     return userJson.villageId;
        // else {
        //     redirectToLogin();
        // }
        return localStorage.getItem('villageId')
    };

    var getVillageName = function(){
    //     if (check())
    //         return userJson.villagesName;
    //     else {
    //         redirectToLogin();
    // }
        return localStorage.getItem('villagesName')
    };

    return {
        getUserId: getUserId,
        getUserName: getUserName,
        getVillageId: getVillageId,
        setSession: setSession,
        getVillageName:getVillageName,
        removeSession:removeSession
    }

})();


// WEBPACK FOOTER //
// ./src/utils/session.js